import type { MachineSetupRepository } from '../data/machine-setup-repository';
import type { ThirdPartyManufacturer } from '../types/machine-setup-types';

export class GetMachineSetupManufacturersUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(): Promise<ThirdPartyManufacturer[]> {
    return this.repository.getManufacturers();
  }
}
